
import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useKai } from '../contexts/KaiPresenceContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme, getKaiTheme } = useTheme();
  const { state: kaiState } = useKai();
  
  const kaiTheme = getKaiTheme(kaiState.color);

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-full transition-all duration-300 ${
        theme.mode === 'dark' 
          ? 'bg-slate-800 text-yellow-400 hover:bg-slate-700' 
          : `bg-${kaiTheme.name}-50 text-${kaiTheme.name}-600 hover:bg-${kaiTheme.name}-100`
      }`}
      title={`Switch to ${theme.mode === 'light' ? 'Dark' : 'Light'} Mode`}
    >
      {theme.mode === 'light' ? <Moon size={20} /> : <Sun size={20} />}
    </button>
  );
};
